"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withStyles = _interopRequireDefault(require("../withStyles"));

var _color = _interopRequireDefault(require("color"));

var _util = require("../util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getChildColor = function getChildColor(theme, props) {
  var color;
  var darkColor;

  try {
    // if the button is disabled
    if (props.disabled) {
      return theme.colors["gray300"];
    } // if the button is using one of the string keys for color


    if ((0, _util.checkString)(props.color)) {
      color = theme.colors[props.color]["500"];
      darkColor = theme.colors[props.color]["900"];

      if (props.isOutlined || props.isTransparent) {
        return color;
      } else if (props.isSecondary) {
        return darkColor;
      } else {
        return (0, _color["default"])(color).isDark() ? theme.colors.white : theme.colors.black;
      }
    } else {
      if ((0, _color["default"])(props.color)) {
        if (props.isOutlined || props.isTransparent) {
          return (0, _color["default"])(props.color).string();
        }

        if (props.isSecondary) {
          if ((0, _color["default"])(props.color).isLight()) {
            return (0, _color["default"])(props.color).darken(0.8).string();
          } else {
            return (0, _color["default"])(props.color).darken(0.5).string();
          }
        } else {
          return (0, _color["default"])(props.color).isDark() ? theme.colors.white : theme.colors.black;
        }
      } else {
        throw new Error("Not a valid color string for prop type 'color'");
      }
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn(err);
    return theme.colors.white;
  }
};

var getBackgroundColor = function getBackgroundColor(theme, props) {
  try {
    if (props.disabled && props.isOutlined || props.disabled && props.isTransparent) {
      return "transparent";
    }

    if (props.disabled) {
      return theme.colors["gray100"];
    }

    var color;
    var lightColor;

    if ((0, _util.checkString)(props.color)) {
      color = theme.colors[props.color]["500"];
      lightColor = theme.colors[props.color]["050"];

      if (props.isOutlined || props.isTransparent) {
        return "transparent";
      }

      if (props.isSecondary) {
        return lightColor;
      } else {
        return color;
      }
    } else {
      if ((0, _color["default"])(props.color)) {
        if (props.isOutlined || props.isTransparent) {
          return "transparent";
        }

        if (props.isSecondary) {
          if ((0, _color["default"])(props.color).isLight()) {
            return (0, _color["default"])(props.color).lighten(0.25).string();
          } else {
            return (0, _color["default"])(props.color).lighten(0.5).string();
          }
        }

        return props.color;
      }
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn(err);
    return theme.colors.black;
  }
};

var getHoverColor = function getHoverColor(theme, props) {
  try {
    if (props.disabled) {
      return theme.colors["gray100"];
    }

    if ((0, _util.checkString)(props.color)) {
      if (props.isOutlined || props.isTransparent) {
        return theme.colors[props.color]["050"];
      }

      if (props.isSecondary) {
        return theme.colors[props.color]["200"];
      }

      if ((0, _color["default"])(theme.colors[props.color]["500"]).isDark()) {
        return theme.colors[props.color]["300"];
      } else {
        return theme.colors[props.color]["700"];
      }
    } else {
      if ((0, _color["default"])(props.color)) {
        if (props.isOutlined || props.isTransparent) {
          return (0, _color["default"])(props.color).lighten(0.5).string();
        }

        if (props.isSecondary) {
          return (0, _color["default"])(props.color).lighten(0.2).string();
        }

        if ((0, _color["default"])(props.color).isDark()) {
          return (0, _color["default"])(props.color).lighten(0.2).string();
        } else {
          return (0, _color["default"])(props.color).darken(0.2).string();
        }
      }
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn(err);
    return theme.colors["gray700"];
  }
};

var getRippleColor = function getRippleColor(theme, props) {
  try {
    if (props.disabled) {
      return theme.colors["gray100"];
    }

    if ((0, _util.checkString)(props.color)) {
      if (props.isOutlined || props.isSecondary || props.isTransparent) {
        return theme.colors[props.color]["200"];
      }

      return theme.colors[props.color]["500"];
    } else {
      if ((0, _color["default"])(props.color)) {
        return props.color;
      }
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn(err);
    return theme.colors.black;
  }
};

var getBorderColor = function getBorderColor(theme, props) {
  try {
    if (props.disabled && !props.isTransparent) {
      return theme.colors["gray100"];
    }

    if (props.isTransparent) {
      return "transparent";
    }

    if ((0, _util.checkString)(props.color)) {
      return theme.colors[props.color]["500"];
    } else {
      if ((0, _color["default"])(props.color)) {
        return props.color;
      }
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn(err);
    return theme.colors.black;
  }
};
/**
 * A component used to render a styled button.
 */


var Button =
/*#__PURE__*/
function (_Component) {
  _inherits(Button, _Component);

  function Button(props) {
    var _this;

    _classCallCheck(this, Button);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Button).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "ripple", void 0);

    _defineProperty(_assertThisInitialized(_this), "rippleTimeout", void 0);

    _defineProperty(_assertThisInitialized(_this), "toggleRipple", function () {
      _this.setState(function (state) {
        return {
          rippleActive: !state.rippleActive
        };
      }, function () {
        return _this.rippleTimeout = setTimeout(function () {
          _this.setState(function (state) {
            return {
              rippleActive: !state.rippleActive
            };
          });
        }, 401);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      var button = e.target;
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          disabled = _this$props.disabled;
      var parentOffset = button.getBoundingClientRect();
      var relX = Math.round(e.clientX - parentOffset.left);
      var relY = Math.round(e.clientY - parentOffset.top);

      if (_this.ripple) {
        _this.ripple.style.top = relY + "px";
        _this.ripple.style.left = relX + "px";
      }

      _this.toggleRipple(); // Call this.props.onClick if it exists, or don't do anything if disabled


      if (onClick && !disabled) {
        onClick(e);
      } else if (disabled) {
        e.preventDefault();
      }
    });

    _this.state = {
      rippleActive: false
    };
    return _this;
  }

  _createClass(Button, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.rippleTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          classes = _this$props2.classes,
          className = _this$props2.className,
          color = _this$props2.color,
          Element = _this$props2.element,
          icon = _this$props2.icon,
          iconAlign = _this$props2.iconAlign,
          innerClassName = _this$props2.innerClassName,
          isOutlined = _this$props2.isOutlined,
          isSecondary = _this$props2.isSecondary,
          isTransparent = _this$props2.isTransparent,
          theme = _this$props2.theme,
          rest = _objectWithoutProperties(_this$props2, ["children", "classes", "className", "color", "element", "icon", "iconAlign", "innerClassName", "isOutlined", "isSecondary", "isTransparent", "theme"]);

      var rippleActive = this.state.rippleActive;
      return (// $FlowFixMe
        _react["default"].createElement(Element, _extends({
          className: (0, _classnames["default"])(classes.root, className)
        }, rest, {
          onClick: this.handleClick
        }), _react["default"].createElement("div", {
          className: classes.innerContainer
        }, _react["default"].createElement("div", {
          className: (0, _classnames["default"])(classes.children, innerClassName)
        }, icon && iconAlign === "left" ? _react["default"].createElement("div", {
          className: (0, _classnames["default"])(classes.icon, classes.iconLeft)
        }, icon) : null, children, icon && iconAlign === "right" ? _react["default"].createElement("div", {
          className: (0, _classnames["default"])(classes.icon, classes.iconRight)
        }, icon) : null), _react["default"].createElement("span", {
          ref: function ref(ripple) {
            return _this2.ripple = ripple;
          },
          className: (0, _classnames["default"])(classes.ripple, rippleActive && classes.rippleActive)
        })))
      );
    }
  }]);

  return Button;
}(_react.Component);

_defineProperty(Button, "defaultProps", {
  color: "primary",
  element: "button",
  iconAlign: "left",
  isOutlined: false,
  isSecondary: false,
  isTransparent: false
});

var styles = function styles(theme) {
  return {
    root: {
      display: "inline-flex",
      position: "relative",
      justifyContent: "center",
      alignItems: "center",
      textDecoration: "none !important",
      backgroundColor: function backgroundColor(props) {
        return getBackgroundColor(theme, props);
      },
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: function borderColor(props) {
        return props.isOutlined ? getBorderColor(theme, props) : "transparent";
      },
      borderRadius: theme.globalBorderRadius,
      transition: theme.transitions["default"],
      overflow: "hidden",
      cursor: function cursor(props) {
        if (props.disabled) {
          return "not-allowed";
        } else if (props.element === "a") {
          return "pointer";
        } else {
          return "default";
        }
      },
      "&:hover, &:active": {
        backgroundColor: function backgroundColor(props) {
          return getHoverColor(theme, props);
        }
      }
    },
    innerContainer: {
      flex: "1 1 auto",
      position: "relative",
      zIndex: theme.zIndex["buttonBase"]
    },
    children: {
      display: "flex",
      position: "relative",
      justifyContent: "center",
      alignItems: "center",
      color: function color(props) {
        return getChildColor(theme, props);
      },
      fontFamily: theme.typography.sans,
      fontSize: "14px",
      lineHeight: "20px",
      fontWeight: "600",
      textDecoration: "inherit",
      padding: function padding(props) {
        return props.icon ? "8px 16px" : "10px 16px";
      },
      zIndex: theme.zIndex["buttonChildren"]
    },
    icon: {
      flexShrink: "0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      pointerEvents: "none"
    },
    iconLeft: {
      marginLeft: "-4px",
      marginRight: "6px"
    },
    iconRight: {
      marginLeft: "6px",
      marginRight: "-4px"
    },
    ripple: {
      display: "block",
      position: "absolute",
      width: "0",
      height: "0",
      borderRadius: "50%",
      transform: "translate(-50%, -50%)",
      transition: "width 0.4s ease-in-out, height 0.4s ease-in-out",
      backgroundClip: "padding-box",
      zIndex: theme.zIndex["buttonBase"],
      backgroundColor: function backgroundColor(props) {
        return getRippleColor(theme, props);
      }
    },
    rippleActive: {
      animation: "ripple .4s ease-in"
    },
    "@keyframes ripple": {
      "0%": {
        opacity: "0"
      },
      "25%": {
        opacity: "1"
      },
      "100%": {
        width: "200%",
        paddingBottom: "200%",
        opacity: "0"
      }
    }
  };
};

var _default = (0, _withStyles["default"])(styles, {
  name: "EuiButton"
})(Button);

exports["default"] = _default;